export function getModuleName(moduloName: string) {
    switch (moduloName) {
        case "educacao":
            return "Escola";
        case "merenda":
            return "Merenda";
        case "veiculo":
            return "Veículo";
        case "biblioteca":
            return "Biblioteca";
        case "financeiro":
            return "Financeiro";
        case "sgfem":
            return "SGFEM";
        case "rh":
            return "R.H.";
        case "almoxarifado":
            return "Almoxarifado";
        default:
            return "Omega Sistemas";
    }
}
